import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Caption1, Label, RocketSmallIcon, SelectTrigger, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";
import { CallToUpgradeLink } from "~/components/CallToUpgradeLink/CallToUpgradeLink";
import TimeEstimatesPanel from "~/components/tasks/TaskPanel/TimeEstimatesPanel";
import { TaskSplits } from "~/components/TaskSplits/TaskSplits";
import { getIsFeatureEnabled } from "~/store/selectors/selector.configOptions";

export const TaskEstimatesContainer = ({ estimate, handleChange, jobTypeId, canEdit, isSplit, taskId }) => {
  const { t } = useTranslation();
  const taskEstimatesEnabled = useSelector((state) => getIsFeatureEnabled(state, "task_estimates"));
  const workloadPlusEnabled = useSelector((state) => getIsFeatureEnabled(state, "workload_plus"));

  if (!taskEstimatesEnabled && !canEdit) {
    return null;
  }

  return (
    <div>
      <div
        tabIndex="-1"
        className="tw-mb-6"
      >
        <div className="tw-flex tw-justify-between tw-mb-1 tw-items-center">
          <Label size="small">{t("Time Estimation")}</Label>

          {!taskEstimatesEnabled ? (
            <Tooltip title={t("Upgrade to Unlock Time Estimation")}>
              <div>
                <CallToUpgradeLink
                  ownerChildren={
                    <Caption1
                      as={Link}
                      color="theme-primary"
                      className="tw-cursor-pointer tw-flex tw-items-center tw-justify-between"
                    >
                      {t("Upgrade")}
                      <RocketSmallIcon className="tw-fill-primary" />
                    </Caption1>
                  }
                  memberChildren={
                    <Caption1
                      color="theme-primary"
                      className="tw-cursor-pointer tw-flex tw-items-center tw-justify-between"
                    >
                      {t("Upgrade")}
                      <RocketSmallIcon className="tw-fill-primary" />
                    </Caption1>
                  }
                  features={["task_estimates"]}
                  context="Time Estimation"
                  page="Task"
                />
              </div>
            </Tooltip>
          ) : (
            <>
              {workloadPlusEnabled ? (
                <TaskSplits taskId={taskId} />
              ) : (
                <Tooltip title={t("Upgrade to Pro+Get Paid")}>
                  <div>
                    <CallToUpgradeLink
                      ownerChildren={
                        <Caption1
                          as={Link}
                          color="theme-primary"
                          className="tw-cursor-pointer tw-flex tw-items-center tw-justify-between"
                        >
                          <RocketSmallIcon className="tw-fill-primary" />
                          {t("Split")}
                        </Caption1>
                      }
                      memberChildren={
                        <Caption1
                          color="theme-primary"
                          className="tw-cursor-pointer tw-flex tw-items-center tw-justify-between"
                        >
                          <RocketSmallIcon className="tw-fill-primary" />
                          {t("Split")}
                        </Caption1>
                      }
                      features={["workload_plus"]}
                      context="Workload Plus"
                      page="Task"
                    />
                  </div>
                </Tooltip>
              )}
            </>
          )}
        </div>
        {taskEstimatesEnabled ? (
          <TimeEstimatesPanel
            estimate={estimate}
            handleChange={handleChange}
            jobTypeId={jobTypeId}
            canEdit={canEdit && taskEstimatesEnabled}
            isSplit={isSplit}
          />
        ) : (
          <SelectTrigger
            className="tw-w-full"
            disabled
          >
            {t("Set...")}
          </SelectTrigger>
        )}
      </div>
    </div>
  );
};

TaskEstimatesContainer.propTypes = {
  estimate: PropTypes.string,
  handleChange: PropTypes.func,
  jobTypeId: PropTypes.number,
  canEdit: PropTypes.bool,
  isSplit: PropTypes.bool,
  taskId: PropTypes.number.isRequired,
};
